// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// SDK_VERSION should be updated in all 3 package.json and lerna.json(by running lerna version)
export const SDK_VERSION = "7.0.1";
